<template>
  <div class="">
    <div>
      <b-form-group
        id="accountPickerGroup"
        :label="labelName === null ? 'Select an Account' : labelName"
        label-for="accountPicker"
      >
        <b-form-input
          id="accountPicker"
          type="text"
          v-model="accountInput"
          placeholder="Enter name"
          debounce="999"
          @input="onChange"
          autocomplete="off"
        />
      </b-form-group>
    </div>
    <div class="mt-0">
      <div>
        <div
          class="row m-1 p-2 suggested-account"
          v-for="account in this.filteredAccounts"
          :key="account.id"
        >
          <div class="col-1 text-center">
            <i
              v-if="account.account_type === 'Individual'"
              class="fas fa-user"
            ></i>
            <i
              v-if="account.account_type === 'Organization'"
              class="fas fa-building"
            ></i>
          </div>
          <div
            class="col-10"
            v-on:click="
              e => {
                accountSelected(e, account);
              }
            "
          >
            {{ account.name }}
            <span class="employer" v-if="account.account_type === 'Individual'">
              <br />
              <b>{{ account.organization_name }}</b> - {{ account.job_title }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../api/index";

export default {
  name: "account-picker",
  props: ["accountID", "labelName"],
  data: function() {
    return {
      accountInput: "",
      filteredAccounts: [],
      selectedAccount: null,
      selectedAccountID: "",
      isTyping: false
    };
  },
  watch: {
    accountID: function(newVal, oldVal) {
      if (newVal === null) {
        this.selectedAccount = null;
        this.selectedAccountID = "";
        this.accountInput = "";
      }
    }
  },
  methods: {
    onBlur() {
      this.filteredAccounts = [];
    },
    onChange() {
      //  start making suggestions after more than two characters have been entered.
      setTimeout(() => {
        this.isTyping = false;
        if (this.accountInput.length > 1) {
          console.log(this.accountInput.length);
          API.getAutocompleteAccountV2({ name: this.accountInput }).then(
            response => {
              this.filteredAccounts = response.data;
            }
          );
        } else {
          this.filteredAccounts = [];
        }
      }, 1000);
      this.isTyping = true;
    },
    accountSelected(e, account) {
      e.preventDefault();
      this.mountAccount(account);
    },
    mountAccount(account) {
      this.$emit("selectedAccount", account);
      this.filteredAccounts = [];
      if (
        account.account_type === "Individual" &&
        account.organization_name != null
      ) {
        this.accountInput = account.organization_name;
        console.log(this.accountInput);
        this.onChange(this.accountInput);
      } else this.accountInput = "";
    }
  },
  mounted() {}
};
</script>

<style scoped>
.suggested-account {
  border: solid 1px #eee;
  cursor: pointer;
  background: #ffffff;
}
.suggested-account:hover {
  background: #eee;
}
.employer {
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/tools/AccountSelector.vue